export enum ButtonType {
  DEFAULT = 'default',
  JOIN_THE_PROGRAM = 'join-the-program',
  OTO_PAGE_ACCEPT = 'oto-page-accept',
}
